<div class="cx-footer-navigation-bar">
  @for (item of data.items; track $index) {
    @if (item.url) {
      <cx-link [link]="item" styleClass="link-hover-underline" />
    } @else {
      <span>{{ item.linkName }}</span>
    }
  }
</div>
